import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFooter = styled(Box)({
  backgroundColor: 'transparent',
  padding: '1rem 0',
  marginTop: '0.5rem',
  position: 'relative',
  borderTop: '1px solid rgba(0,0,0,0.1)',
});

const FooterContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.6rem',
  textAlign: 'center',
  maxWidth: '550px',
  margin: '0 auto',
  padding: '0 1.5rem',
});

const BrandSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.8rem',
  marginBottom: '0.2rem',
  padding: '0.8rem 1.5rem',
  backgroundColor: 'rgba(14, 165, 233, 0.1)',
  borderRadius: '25px',
  border: '1px solid rgba(14, 165, 233, 0.2)',
  transition: 'all 0.2s ease',
  boxShadow: '0 2px 8px rgba(14, 165, 233, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(14, 165, 233, 0.15)',
    borderColor: 'rgba(14, 165, 233, 0.25)',
    boxShadow: '0 4px 12px rgba(14, 165, 233, 0.15)',
  }
});

const PoweredByText = styled(Typography)({
  color: '#475569',
  fontSize: '0.85rem',
  fontWeight: 600,
});

const CompanyName = styled(Typography)({
  color: '#0ea5e9',
  fontSize: '1.1rem',
  fontWeight: 800,
  letterSpacing: '0.5px',
  textShadow: '0 1px 2px rgba(14, 165, 233, 0.1)',
});

const Tagline = styled(Typography)({
  color: '#374151',
  fontSize: '0.8rem',
  fontWeight: 600,
  maxWidth: '500px',
  lineHeight: 1.4,
  marginBottom: '0.2rem',
  opacity: 0.95,
});

const DividerStyled = styled(Divider)({
  width: '100%',
  maxWidth: '300px',
  margin: '0.4rem 0',
  borderColor: '#d1d5db',
  opacity: 0.4,
  height: '1px',
});

const CopyrightText = styled(Typography)({
  color: '#6b7280',
  fontSize: '0.75rem',
  fontWeight: 600,
  lineHeight: 1.4,
  opacity: 0.9,
});

export default function Footer() {
  return (
    <StyledFooter>
      <FooterContent>
        <BrandSection>
          <CompanyName variant="body1">
            SPAS & OSUS
          </CompanyName>
          <PoweredByText variant="body1">
            Powered by
          </PoweredByText> 
        </BrandSection>
        
        <Tagline variant="body1">
          Leading the future of intelligent business solutions
        </Tagline>
        
        <DividerStyled />
        
        <CopyrightText variant="body2">
          © {new Date().getFullYear()} Spas & OSUS. All rights reserved.
        </CopyrightText>
      </FooterContent>
    </StyledFooter>
  );
}